import { fetchJSON } from "../helpers/fetcher"
import { ENVIRONMENT, getEndpoint } from "./endpoints"

const tiktokLogoutUrl = getEndpoint(ENVIRONMENT)?.veeqoLogout as string

export class VeeqoAuthService {
  private static veeqoClientID = process.env.REACT_APP_VEEQO_CLIENT_ID
  private static veeqoRedirect = process.env.REACT_APP_VEEQO_REDIRECT
  private static veeqoAuthorizeUrl = process.env.REACT_APP_VEEQO_AUTH

  static authorize = (userEmailAndCognitoEncoded: string) => {
    window.location.href = `${this.veeqoAuthorizeUrl}?client_id=${this.veeqoClientID}&redirect_uri=${this.veeqoRedirect}&response_type=code&state=${userEmailAndCognitoEncoded}`
  }

  static logout = async () => {
    return await fetchJSON(tiktokLogoutUrl, "POST", {})
  }
}
